const cachedFetchPromises = {};
const cacheTime = 10 * 1000; // 10 seconds
export const cachedFnCall = (id, fn) => {
  const cached = (() => {
    const _cached = cachedFetchPromises[id];
    if (!_cached) return null;
    if (Date.now() - _cached.time > cacheTime) {
      delete cachedFetchPromises[id];
      return null;
    }
    return _cached;
  })();

  if (!cached) {
    cachedFetchPromises[id] = {
      time: Date.now(),
      res: fn(),
    };
  }

  return cachedFetchPromises[id].res;
};
